import http from '../components/http/http';
import { getBiomarkerFields, getDefatultIndicatorValues } from './biomarkers';

// Types
export interface GlobalVariable {
  info?: {
    indicators: any[];
    interpretations: any[];
    recommendations: any[];
    subjects: any[];
    total: {
      R: number;
      A: number;
      G: number;
      GREY: 0;
      total: number;
      value: string;
    };
  };
  values?: Record<string, any>;
}

// Config management
let config: any = {};

export const getConfig = (key: string, defaultValue: any) => {
  console.log('Config access:', config, key, defaultValue);
  return config[key] || defaultValue;
};

export const setConfig = (newConfig: any) => {
  config = newConfig;
};

// Biomarker initialization
export const initializeBiomarkers = () => {
  const fields = getBiomarkerFields();
  const values = getDefatultIndicatorValues();
  
  const updatedFields = fields.filter((field: any) => {
    if (Number(field.indicatorId)) {
      const existingField = fields.find((f: any) => f.indicatorId == field.indicatorId);
      if (!existingField) {
        fields.push({ indicatorId: +field.indicatorId, value: values[field.indicatorId] });
      }
    }
    return values.hasOwnProperty(field.indicatorId);
  });

  localStorage.setItem('indicator_values', JSON.stringify(
    updatedFields.map((field: any) => [field.indicatorId, field.value])
  ));
  
  console.log('Biomarker fields initialized:', updatedFields, values);
  return { updatedFields, values };
};

// API functions
export const fetchRecommendations = async (obj: any): Promise<GlobalVariable> => {
  try {
    const response = await http.post('/api/core/analysis/recommendations', obj);
    console.log('API response:', response);
    return response;
  } catch (error) {
    console.log("API error:", error);
    return {
      info: {
        indicators: [],
        interpretations: [],
        recommendations: [],
        subjects: [],
        total: {
          R: 0,
          A: 0,
          G: 0,
          GREY: 0,
          total: 0,
          value: "0.0"
        }
      },
      values: {
        "": null
      }
    };
  }
};

export const fetchAppConfig = async () => {
  try {
    const response = await http.get('/api/config');
    console.log('Config fetched:', response);
    setConfig(response);
    return response;
  } catch (error) {
    console.error('Failed to fetch config:', error);
    return null;
  }
};

// Utility functions
export const checkIfEmpty = (obj: any): boolean => {
  return !Boolean(Object.entries(obj).filter(([key, value]) => key !== '' && value !== '').length);
};
